import {
    abbrNumberVisitsFilter,
    abbrNumberWithNASupportVisitsFilter,
    decimalNumberFilter,
    percentageSignFilter,
} from "../../../../app/filters/ngFilters";

import type { IScatterItem } from "../types/conversionTypes";

export interface IConversionVertical {
    title: string;
    tooltipInfo: string;
    dataKey: string;
    filter: any;
    yAxisFilter?: any;
    name: string;
    metricLabel: string;
    midValueCalculator?: (data: IScatterItem[]) => number;
}

interface IConversionVerticals {
    Visits: IConversionVertical;
    ConvertedVisits: IConversionVertical;
    ConvertionRate: IConversionVertical;
    Stickiness: IConversionVertical;
}

function stickinessFormatter() {
    return (num: number) => {
        return num !== 0 ? decimalNumberFilter()(num, true) || "N/A" : "N/A";
    };
}

export const conversionVerticals: IConversionVerticals = {
    Visits: {
        title: "conversion.category.tab.visits",
        tooltipInfo: "category.converstion.table.tooltip.visits",
        dataKey: "Visits",
        filter: [abbrNumberWithNASupportVisitsFilter, 1],
        yAxisFilter: [abbrNumberVisitsFilter, 1],
        name: "Visits",
        metricLabel: "Scale",
        midValueCalculator: (data) => {
            return (
                data.reduce((sum, item) => {
                    return sum + item.Visits;
                }, 0) / data.length
            );
        },
    },
    ConvertedVisits: {
        title: "conversion.category.tab.convertedVisits",
        tooltipInfo: "conversion.home.leaderboard.table.tooltip.converted.visits",
        dataKey: "ConvertedVisits",
        filter: [abbrNumberWithNASupportVisitsFilter, 2],
        yAxisFilter: [abbrNumberVisitsFilter, 2],
        name: "ConvertedVisits",
        metricLabel: "Scale",
        midValueCalculator: (data) => {
            return (
                data.reduce((sum, item) => {
                    return sum + item.ConvertedVisits;
                }, 0) / data.length
            );
        },
    },
    ConvertionRate: {
        title: "conversion.category.tab.conversionRate",
        tooltipInfo: "conversion.home.leaderboard.table.tooltip.conversion.rate",
        dataKey: "ConversionRate",
        filter: [percentageSignFilter, 1],
        name: "ConvertionRate",
        metricLabel: "Efficiency",
        midValueCalculator: (data) => {
            const { visits, convertedVisits } = data.reduce(
                (acc, item) => {
                    return {
                        visits: acc.visits + item.Visits,
                        convertedVisits: acc.convertedVisits + item.ConvertedVisits,
                    };
                },
                { visits: 0, convertedVisits: 0 },
            );

            return convertedVisits / visits;
        },
    },
    Stickiness: {
        title: "conversion.category.tab.purchasesPerCustomer",
        tooltipInfo: "conversion.home.leaderboard.table.tooltip.stickiness",
        dataKey: "Stickiness",
        filter: [stickinessFormatter, 1],
        yAxisFilter: [decimalNumberFilter, 1],
        name: "Stickiness",
        metricLabel: "Efficiency",
        midValueCalculator: (data) => {
            const { divident, divisor } = data.reduce(
                (acc, item) => {
                    return {
                        divident: acc.divident + item.ConvertedVisits * item.Stickiness,
                        divisor: acc.divisor + item.ConvertedVisits,
                    };
                },
                { divident: 0, divisor: 0 },
            );

            return divident / divisor;
        },
    },
};
